<template>
  <b-card
    :title="translations.cancelTransaction[lang]"
    :loading="refundLoading"
    :error-message="errorMessage"
    @cancel="$emit('cancel')"
    @submit="
      cancelTransaction({
        id: transactionId,
        token: '',
        query,
      })
    "
  >
    <div v-if="loading" no-gutters class="text-center">
      <v-progress-circular indeterminate></v-progress-circular>
    </div>

    <template v-else>
      <v-row no-gutters class="pa-3">
        <v-col cols="5" class="subtitle-2">{{ translations.productName[lang] }}</v-col>
        <v-col cols="3" class="subtitle-2">{{ translations.totalPrice[lang] }}</v-col>
        <v-col cols="2" class="subtitle-2">{{ translations.quantity[lang] }}</v-col>
        <v-col cols="2" class="subtitle-2">{{ translations[storeMode][lang] }}</v-col>
      </v-row>
      <v-row
        v-for="(product, i) in transactionCancel.products"
        :key="product.product_id"
        no-gutters
        align="baseline"
        class="b-outlined px-3 pt-7"
        :class="{ 'mt-3': i !== 0 }"
      >
        <v-col cols="5">
          {{ product.name[lang] }}
        </v-col>
        <v-col cols="3">
          {{
            new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'EUR',
              minimumFractionDigits: 2,
            }).format(product.max_retail_price)
          }}
        </v-col>
        <v-col cols="2">
          {{ product.total_litres || product.quantity }}
        </v-col>
        <v-col cols="2">
          {{ product.points }}
        </v-col>
        <!-- {{ product }}---------
                {{ transactionProfile.transaction_items }} -->
        <!-- <v-col cols="2" class="text-right"> -->
        <!-- <v-tooltip color="secondary" top>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                color="red"
                                class="mb-1"
                                icon
                                v-on="on"
                                @click="transactionCancel.products.splice(i, 1)"
                            >
                                <v-icon v-text="icons.mdiClose"></v-icon>
                            </v-btn>
                        </template>

                        <span class="font-weight-bold">Remove From List</span>
                    </v-tooltip> -->
        <!-- </v-col> -->
      </v-row>
    </template>
  </b-card>
</template>

<script>
import { mdiClose } from '@mdi/js';
import { mapActions, mapState } from 'vuex';

import TransactionProduct from '@/models/storePanel/TransactionProduct';
import translations from '@/utils/translations/storePanel/transactions';

export default {
  name: 'CancelTransaction',

  props: {
    transactionId: [String, Number],
  },

  mixins: [translations],

  data: () => ({
    icons: { mdiClose },
    transactionCancel: {},
  }),

  computed: {
    ...mapState(['loading', 'errorMessage']),

    lang() {
      return this.$route.params.lang;
    },
    storeMode() {
      return this.$store.state.store?.display_mode || 'points';
    },
    refundLoading() {
      return this.$store.state.storePanel.transactions.refundLoading;
    },

    transactionProfile() {
      return this.$store.state.storePanel.transactions.transactionProfile;
    },

    query() {
      let query = '?';

      for (let key in this.$route.query) {
        if (this.$route.query[key]) query += `${key}=${this.$route.query[key]}&`;
      }

      return query.slice(0, query.length - 1);
    },
  },

  methods: {
    ...mapActions('storePanel/transactions', ['getItem', 'cancelTransaction']),
  },

  watch: {
    transactionProfile(val) {
      this.transactionCancel = {
        transaction_id: val.transaction_id,
        products: [],
      };

      val.transaction_items.forEach((p) => {
        p.name = p.product_name;
        p.retail_price = p.price;
        this.transactionCancel.products.push(new TransactionProduct(p));
      });

      this.transactionCancel.products.forEach((p) => {
        p.max_quantity = p.quantity;
        p.max_retail_price = p.retail_price;
      });
    },

    transactionId: {
      immediate: true,
      handler(val) {
        this.getItem(val);
      },
    },
  },
};
</script>

<style scoped>
.b-floating-btn {
  position: absolute;
  top: 0;
  right: 0;
}
</style>
